var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.224 0H1.71379C1.25926 0 0.823354 0.174956 0.501957 0.486379C0.180559 0.797801 0 1.22018 0 1.6606L0 17.5897C0 18.0301 0.180559 18.4525 0.501957 18.7639C0.823354 19.0753 1.25926 19.2503 1.71379 19.2503H10.4465V11.5766H8.32333V8.78955H10.4683V7.73184C10.4683 6.75875 10.4137 5.24094 11.6963 4.02986C12.1753 3.60093 12.7422 3.27467 13.3601 3.07237C13.9779 2.87007 14.6329 2.79628 15.2822 2.85581H16.8104V5.71691C16.8104 5.71691 15.3477 5.48421 14.589 5.84912C14.258 6.04088 13.9897 6.31936 13.8149 6.65245C13.6401 6.98555 13.566 7.35971 13.6011 7.73184V8.78955H16.8104V11.5766H13.6011V19.2503H18.224C18.6781 19.2489 19.1131 19.0735 19.4342 18.7624C19.7553 18.4512 19.9363 18.0297 19.9378 17.5897V1.6606C19.9363 1.22061 19.7553 0.79904 19.4342 0.487919C19.1131 0.176798 18.6781 0.00139459 18.224 0",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon_fb.41e74e08ce97c7da68e106731bad1b7d.svg";
export { ForwardRef as ReactComponent };